const viewAny = (permissions) => {
  return permissions.includes('read-email-templates')
}

const create = (permissions) => {
  return hasPermission(permissions, 'create-email-templates')
}

const update = (permissions, emailTemplate) => {
  return hasPermission(permissions, 'update-email-templates')
}

const deletee = (permissions, emailTemplate) => {
  return hasPermission(permissions, 'delete-email-templates')
}

const hasPermission = (permissions, permission) => {
  return permissions.includes(permission)
}

export {
  viewAny,
  create,
  update,
  deletee,
  hasPermission,
};